import * as React from "react";
import { IconBase, IIconBase } from "./IconBase";

export const OtherDocumentsIcon = ({ ...props }: IIconBase) => (
  <IconBase {...props}>
    <title>Other Documents</title>
    <path d="M30 4H11v11H7v29h35V16zm0 5.75L36.25 16H30zM29 31v9H11V19h6v12h12zm-8-4v-6.24L27.25 27zm17 13h-5V27l-7-7-5-5h-6V8h11v12h12z" />
  </IconBase>
);
